// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2VHMF","label":"Completed_label__IrIgX"};